import $ from 'jquery';
$(document).ready(() => {
    function toggleSearch() {
        //toogle sur la loupe de recherche dans la navigation
        $(".search-button").click(function (event) {
            event.preventDefault();
            $(".search-container").slideToggle('fast');
            // e.stopPropagation();
        });
        $('.search-button').on('click', function () {
            $(this).toggleClass("active");
        });
    }
    toggleSearch();

    function mobileNav() {
        let nav = $('.main-navigation-mobile');
        let html = $('html');
        let modalMenu = $('.modal-menu');
        $(window).on('load resize', function () {
            if ($(this).width() < 992) {
                nav.addClass('mobile-place');
                $('.burger').click(function () {
                    $(this).toggleClass('open');
                    nav.toggleClass('show');
                    html.toggleClass('overflow-hidden');
                    modalMenu.toggleClass('show');
                });
            } else {
                nav.removeClass('mobile-place');
            }
        });
    }
    mobileNav();

    function navsticky() {
        // Sticky Header
        let sticky = $('.sticky-row');
        let siteMain = $('.site-main');
        $(window).scroll(function () {
            if ($(window).scrollTop() > 0) {
                sticky.addClass('top-fixed');

            } else {
                sticky.removeClass('top-fixed');
            }
        });
    }
    navsticky()

    /**
     * slider menu on mobile
     */
    function navswippe() {
        if ($(document).width() < 768) {
            $('.extract-level').slick({
                dots: false,
                infinite: false,
                autoplay: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            dots: false,
                            arrows: false,
                            infinite: false,
                            slidesToShow: 2.5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 567,
                        settings: {
                            dots: false,
                            infinite: false,
                            speed: 300,
                            slidesToShow: 1.7,
                            slidesToScroll: 1,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 507,
                        settings: {
                            dots: false,
                            infinite: false,
                            speed: 300,
                            slidesToShow: 1.7,
                            slidesToScroll: 2,
                            arrows: false,
                            variableWidth: true,
                        }
                    },
                ]
            });
        }
    }
    navswippe()

})